import {Injectable} from '@angular/core';
import {Router, UrlTree} from "@angular/router";
import {AuthService} from "../services/auth.service";
import {environment} from "../../environments/environment";
import {Observable, of} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class PreventRouteOnKeycloakGuard {


  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    if (environment.IDENTITY_PROVIDER == 'keycloak') {
      return of(this.router.createUrlTree(["/"]));
    }

    return of(true);
  }

}
